<template>
    <div class="p-login p-login--error">
        <div class="container-xl d-flex align-items-center justify-content-center">
            <div class="p-login__content d-flex flex-column align-items-center justify-content-center">
                <h1>Sorry we didn’t recognize that account</h1>
                <p>Please try to sign in with another account.</p>
                <a class="btn btn-outline-secondary btn-google" @click="login"><img src="../assets/svg/icon-google.png"> Sign in with google</a>
            </div>
      </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'Login Error',

    methods: {
        ...mapActions('user', {
            login: 'login',
        })
    }
}
</script>
